import React, { Component } from 'react'
import { Container, Collapse, Nav, Navbar,
    NavbarToggler, NavbarBrand, NavItem, NavLink, Row, Col,
    UncontrolledDropdown, DropdownToggle, DropdownMenu, Dropdown,
    DropdownItem, Table, ButtonDropdown, Input, Button,
    Modal, ModalHeader, ModalBody, ModalFooter, Alert, Spinner} from 'reactstrap'
import logo from "../../assets/img/logo.png"
import style from '../../assets/css/input.module.css'
import {FaSearch, FaUserCircle, FaBars, FaBarcode} from 'react-icons/fa'
import {AiOutlineFileExcel, AiFillCheckCircle, AiOutlineInbox, AiOutlineClose} from 'react-icons/ai'
import {Formik} from 'formik'
import * as Yup from 'yup'
import asset from '../../redux/actions/asset'
import {connect} from 'react-redux'
import moment from 'moment'
import auth from '../../redux/actions/auth'
import coa from '../../redux/actions/coa'
import {default as axios} from 'axios'
import Sidebar from "../../components/Header";
import MaterialTitlePanel from "../../components/material_title_panel";
import SidebarContent from "../../components/sidebar_content";
import NavBar from '../../components/NavBar'
import styleTrans from '../../assets/css/transaksi.module.css'
import stylesPanel from '../../assets/css/Filterpanel.module.css'
import styleHome from '../../assets/css/Home.module.css'
import NewNavbar from '../../components/NewNavbar'
import ExcelJS from "exceljs"
import fs from "file-saver"
import Barcode from 'react-barcode'
import { BsTable, BsQrCode } from "react-icons/bs";
import * as htmlToImage from 'html-to-image';
import QRCode from "react-qr-code"
import placeholder from  "../../assets/img/placeholder.png"
const {REACT_APP_BACKEND_URL} = process.env

const stockSchema = Yup.object().shape({
    record_type: Yup.string().required("must be filled")
})

const dokumenSchema = Yup.object().shape({
    nama_dokumen: Yup.string().required(),
    jenis_dokumen: Yup.string().required(),
    divisi: Yup.string().required(),
});

const filterSchema = Yup.object().shape({
    no_asset:  Yup.string(),
    date1: Yup.date()
})

// ── Filter Panel constants ──────────────────────────────────────────

const STATUS_OPTIONS = [
    { value: "available", label: "Available", color: "#22c55e", icon: "✔️" },
    { value: "100", label: "Belum di GR", color: "#f59e0b", icon: "⏳" },
    { value: "0", label: "Disposal", color: "#000000", icon: "🗑️" },
    { value: "1", label: "Proses Disposal", color: "#374151", icon: "♻️" },
    { value: "11", label: "Proses Mutasi", color: "#3b82f6", icon: "🔄" },
];

const TAB_LABELS = {
    coa_beban:     "COA Beban",
    coa_akumulasi: "COA Akumulasi",
    coa_asset:     "COA Asset",
};
// ───────────────────────────────────────────────────────────────────

class Asset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            docked: false,
            open: false,
            transitions: true,
            touch: true,
            shadow: true,
            pullRight: false,
            touchHandleWidth: 20,
            dragToggleDistance: 30,
            alert: false,
            confirm: "",
            isOpen: false,
            dropOpen: false,
            dropOpenNum: false,
            value: '',
            onChange: new Date(),
            sidebarOpen: false,
            modalAdd: false,
            modalEdit: false,
            modalUpload: false,
            modalDownload: false,
            modalConfirm: false,
            detail: {},
            dataDivisi: [],
            upload: false,
            errMsg: '',
            fileUpload: '',
            limit: 10,
            search: '',
            listAsset: [],
            openChoose: false,
            images: [],
            isLoading: false,
            onQr: false,
            // ── Filter Panel state ──
            isPanelOpen: false,
            activeTab: "coa_beban",
            filters: {
                coa_beban:     [],
                coa_akumulasi: [],
                coa_asset:     [],
                status:        [],
            },
        }
        this.onSetOpen       = this.onSetOpen.bind(this);
        this.menuButtonClick = this.menuButtonClick.bind(this);
        this.canvasRefs      = []
        this.barcodeRefs     = {};
        // ── Filter Panel bindings ──
        this.togglePanel = this.togglePanel.bind(this);
        this.closePanel  = this.closePanel.bind(this);
        this.switchTab   = this.switchTab.bind(this);
        this.toggleItem  = this.toggleItem.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleApply = this.handleApply.bind(this);
    }

    // ── Filter Panel methods ────────────────────────────────────────
    togglePanel() {
        this.setState((prev) => ({ isPanelOpen: !prev.isPanelOpen }));
    }

    closePanel() {
        this.setState({ isPanelOpen: false });
    }

    switchTab(tab) {
        this.setState({ activeTab: tab });
    }

    toggleItem(category, value) {
        this.setState((prev) => {
            const current = prev.filters[category];
            const updated = current.includes(value)
                ? current.filter((v) => v !== value)
                : [...current, value];
            return { filters: { ...prev.filters, [category]: updated } };
        });
    }

    handleReset() {
        this.setState({
            filters: { coa_beban: [], coa_akumulasi: [], coa_asset: [], status: [] },
        });
    }

    handleApply = () => {
        // Kirim filters ke getDataAsset atau API sesuai kebutuhan
        this.getDataAsset()
        this.closePanel();
    }
    // ───────────────────────────────────────────────────────────────

    toggleQr = () => {
        this.setState({onQr: !this.state.onQr})
    }

    prosesSidebar = (val) => {
        this.setState({sidebarOpen: val})
    }
    
    goRoute = (val) => {
        this.props.history.push(`/${val}`)
    }

    chekApp = (val) => {
        const { listAsset } = this.state
        const {dataAsset} = this.props.asset
        if (val === 'all') {
            const data = []
            for (let i = 0; i < dataAsset.length; i++) {
                data.push(dataAsset[i].id)
            }
            this.setState({listAsset: data})
        } else {
            listAsset.push(val)
            this.setState({listAsset: listAsset})
        }
    }

    chekRej = (val) => {
        const {listAsset} = this.state
        if (val === 'all') {
            this.setState({listAsset: []})
        } else {
            const data = listAsset.filter(id => id !== val)
            this.setState({listAsset: data})
        }
    }

    downloadData = () => {
        const {listAsset} = this.state
        const {dataAsset} = this.props.asset
        const { dataAll } = this.props.coa
        const dataDownload = []
        for (let i = 0; i < listAsset.length; i++) {
            for (let j = 0; j < dataAsset.length; j++) {
                if (dataAsset[j].id === listAsset[i]) {
                    dataDownload.push(dataAsset[j])
                }
            }
        }

        const workbook = new ExcelJS.Workbook();
        const ws = workbook.addWorksheet('data aset')

        const borderStyles = {
            top: {style:'thin'},
            left: {style:'thin'},
            bottom: {style:'thin'},
            right: {style:'thin'}
        }

        ws.columns = [
            {header: 'Asset', key: 'c2'},
            {header: 'SNo.', key: 'c3'},
            {header: 'Cap.Date', key: 'c4'},
            {header: 'Asset Description', key: 'c5'},
            {header: 'Acquis.val.', key: 'c6'},
            {header: 'Accum.dep.', key: 'c7'},
            {header: 'Book val.', key: 'c8'},
            {header: 'Plant', key: 'c9'},
            {header: 'Cost Ctr', key: 'c10'},
            {header: 'Cost Ctr Name', key: 'c11'},
            {header: 'MERK', key: 'c12'},
            {header: 'SATUAN', key: 'c13'},
            {header: 'JUMLAH', key: 'c14'},
            {header: 'LOKASI', key: 'c15'},
            {header: 'KATEGORI', key: 'c16'},
            {header: 'COA ASSET', key: 'c17'},
            {header: 'COA BEBAN', key: 'c18'},
            {header: 'COA AKUMULASI', key: 'c19'},
            {header: 'UMUR ASSET (Bulan)', key: 'c20'},
            {header: 'NILAI DEPRE / BULAN', key: 'c21'},
            {header: 'SISA UMUR ASSET (SAMPAI BOOK.VAL 0) (Bulan)', key: 'c22'},
            {header: 'STATUS', key: 'c23'}
        ]

        dataDownload.map((item) => {
            const diffVal = parseInt(item.accum_dep)
            const now = moment()
            const past = parseInt(moment(item.tanggal).format('DD')) < 16 ? moment(item.tanggal).subtract(1, 'month') : moment(item.tanggal)  
            // const past = parseInt(moment(item.tanggal).format('DD')) > 15 ? moment(item.tanggal).add(1, 'month') : moment(item.tanggal)  
            // const past = moment(item.tanggal)

            const diffMonth =
            (now.year() - past.year()) * 12 +
            (now.month() - past.month())

            const valMonth = diffVal === 0 ? 0 : diffVal / diffMonth
            const monthRemain = valMonth === 0 ? 0 : (parseInt(item.nilai_acquis) / Math.abs(valMonth)) - diffMonth
            return (
                ws.addRow({
                    c2: item.no_asset,
                    c3: item.no_doc,
                    c4: moment(item.tanggal).format('DD/MM/YYYY'),
                    c5: item.nama_asset,
                    c6: item.nilai_acquis,
                    c7: item.accum_dep,
                    c8: item.nilai_buku,
                    c9: item.kode_plant,
                    c10: item.cost_center,
                    c11: item.area,
                    c12: item.merk,
                    c13: item.satuan,
                    c14: item.unit,
                    c15: item.lokasi,
                    c16: item.kategori,
                    c17: item.coa?.find(x => dataAll.find(y => x === y.no_coa && y.type_coa === 'asset') !== undefined) || "-",
                    c18: item.coa?.find(x => dataAll.find(y => x === y.no_coa && y.type_coa === 'beban') !== undefined) || "-",
                    c19: item.coa?.find(x => dataAll.find(y => x === y.no_coa && y.type_coa === 'akumulasi') !== undefined) || "-",
                    c20: `${diffMonth} Bulan`,
                    c21: item.nilai_buku == 0 ? 0 : `${Math.round(valMonth).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} / Bulan`,
                    c22: diffMonth == 0 ? 'Belum Terdefinisi' : item.nilai_buku == 0 ? 0 : `${Math.round(monthRemain)} Bulan`,
                    c23: item.status === '100' ? 'Asset belum di GR' 
                    : item.status === '0' ? 'Asset telah didisposal' 
                    : item.status === '1' || item.status === '11' ? item.keterangan 
                    : 'available'
                })
            )    
        })

        ws.eachRow({ includeEmpty: true }, function(row) {
            row.eachCell({ includeEmpty: true }, function(cell) {
                cell.border = borderStyles;
            })
        })

        ws.columns.forEach(column => {
            const lengths = column.values.map(v => v.toString().length)
            const maxLength = Math.max(...lengths.filter(v => typeof v === 'number'))
            column.width = maxLength + 5
        })

        workbook.xlsx.writeBuffer().then(function(buffer) {
            fs.saveAs(
                new Blob([buffer], { type: "application/octet-stream" }),
                `Data Asset ${moment().format('DD MMMM YYYY')}.xlsx`
            );
        });
    }

    downloadBarcode = async () => {
        this.setState({isLoading: true})
        const {listAsset} = this.state
        const {dataAsset} = this.props.asset
        const dataDownload = []
        for (let i = 0; i < listAsset.length; i++) {
            for (let j = 0; j < dataAsset.length; j++) {
                if (dataAsset[j].id === listAsset[i]) {
                    dataDownload.push(dataAsset[j])
                }
            }
        }

        const workbook = new ExcelJS.Workbook();
        const ws = workbook.addWorksheet('qr code', {
            pageSetup: { orientation:'portrait', paperSize: 9 }
        })

        const tbStyle        = { horizontal:'center', wrapText: true, vertical: 'middle', shrinkToFit: true }
        const textImgStyle   = { vertical: 'bottom', horizontal: 'center', wrapText: true }
        const boldStyle      = { bold: true }
        const borderStyles   = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} }

        ws.pageSetup.printTitlesRow = '1:2';

        ws.mergeCells(`A${2}`, `H${2}`)
        ws.getCell(`A${2}`).value     = 'Qr Code'
        ws.getCell(`A${2}`).alignment = { ...tbStyle }
        ws.getCell(`A${2}`).border    = { ...borderStyles }
        ws.getCell(`A${2}`).font      = { ...boldStyle }
    
        for (let i = 0; i < dataDownload.length; i++) {
            const item     = dataDownload[i]
            const colFirst = (i % 2) === 0 ? 'A' : 'E'
            const colLast  = (i % 2) === 0 ? 'D' : 'H'
            const numContent = colFirst === 'E' ? 3 + (i - 1) : 3 + i

            ws.mergeCells(`${colFirst}${numContent}`, `${colLast}${numContent}`)

            const cleanText = (str) => str ? str.replace(/[\u0000-\u001F\u007F]/g, '') : ''
            ws.getCell(`${colFirst}${numContent}`).value =
                `${cleanText(item.nama_asset)}\r\nNO ASSET: ${cleanText(item.no_asset)}\r\nCOST CENTER: ${cleanText(item.cost_center) || ''}\r\n`
            ws.getCell(`${colFirst}${numContent}`).alignment = { ...textImgStyle }
            ws.getCell(`${colFirst}${numContent}`).border    = { ...borderStyles }

            ws.getRow(numContent).height = 230
            
            const node = this.barcodeRefs[item.no_asset];
            if (!node) continue;
        
            const dataUrl = await htmlToImage.toPng(node);
            const imageId = workbook.addImage({ base64: dataUrl, extension: 'png' });
            const rowImg  = colFirst === 'E' ? (i - 1) : i
        
            ws.addImage(imageId, {
                tl: { col: colFirst === 'A' ? 0.5 : 4.5, row: rowImg + 2.4 },
                ext: { width: 200, height: 200 },
            });
        }
    
        const buffer = await workbook.xlsx.writeBuffer();
        fs.saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            `Data Qr Code ${moment().format('DD MMMM YYYY')}.xlsx`
        );
        this.setState({isLoading: false})
    }

    showAlert = () => {
        this.setState({alert: true, modalEdit: false, modalAdd: false, modalUpload: false })
        setTimeout(() => { this.setState({ alert: false }) }, 10000)
    }

    next = async () => {
        const { page } = this.props.asset
        const token = localStorage.getItem('token')
        await this.props.nextPage(token, page.nextLink)
    }

    prev = async () => {
        const { page } = this.props.asset
        const token = localStorage.getItem('token')
        await this.props.nextPage(token, page.prevLink)
    }

    uploadAlert = () => {
        this.setState({upload: true, modalUpload: false })
        setTimeout(() => { this.setState({ upload: false }) }, 10000)
    }

    toggle = () => {
        this.setState({isOpen: !this.state.isOpen})
    }

    openConfirm = () => {
        this.setState({modalConfirm: !this.state.modalConfirm})
    }

    downloadTemplate = () => {
        const workbook = new ExcelJS.Workbook();
        const ws = workbook.addWorksheet('data aset')
        const borderStyles = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} }

        ws.columns = [
            {header: 'Asset', key: 'c2'},
            {header: 'SNo.', key: 'c3'},
            {header: 'Cap.Date', key: 'c4'},
            {header: 'Asset Description', key: 'c5'},
            {header: 'Acquis.val.', key: 'c6'},
            {header: 'Accum.dep.', key: 'c7'},
            {header: 'Book val.', key: 'c8'},
            {header: 'Plant', key: 'c9'},
            {header: 'Cost Ctr', key: 'c10'},
            {header: 'Cost Ctr Name', key: 'c11'},
            {header: 'MERK', key: 'c12'},
            {header: 'SATUAN', key: 'c13'},
            {header: 'JUMLAH', key: 'c14'},
            {header: 'LOKASI', key: 'c15'},
            {header: 'KATEGORI', key: 'c16'},
            {header: 'STATUS', key: 'c17'}
        ]

        ws.eachRow({ includeEmpty: true }, function(row) {
            row.eachCell({ includeEmpty: true }, function(cell) { cell.border = borderStyles; })
        })
        ws.columns.forEach(column => {
            const lengths = column.values.map(v => v.toString().length)
            const maxLength = Math.max(...lengths.filter(v => typeof v === 'number'))
            column.width = maxLength + 5
        })
        workbook.xlsx.writeBuffer().then(function(buffer) {
            fs.saveAs(new Blob([buffer], { type: "application/octet-stream" }), `Template Upload Asset.xlsx`);
        });
    }

    dropDown = () => { this.setState({dropOpen: !this.state.dropOpen}) }
    dropOpen  = () => { this.setState({dropOpenNum: !this.state.dropOpenNum}) }

    onSetSidebarOpen = () => { this.setState({ sidebarOpen: !this.state.sidebarOpen }); }
    openModalAdd     = () => { this.setState({modalAdd: !this.state.modalAdd}) }
    openModalEdit    = () => { this.setState({modalEdit: !this.state.modalEdit}) }
    openModalUpload  = () => { this.setState({modalUpload: !this.state.modalUpload}) }
    openModalDownload= () => { this.setState({modalUpload: !this.state.modalUpload}) }

    addDokumen = async (values) => {
        const token = localStorage.getItem("token")
        await this.props.addDokumen(token, values)
        const {isAdd} = this.props.asset
        if (isAdd) {
            this.setState({confirm: 'add'})
            this.openConfirm()
            this.openModalAdd()
            setTimeout(() => { this.getDataAsset() }, 500)
        }
    }

    DownloadMaster = () => {
        const {link} = this.props.asset
        axios({
            url: `${link}`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "master dokumen.xlsx");
            document.body.appendChild(link);
            link.click();
        });
    }

    prosesSync = async (val) => {
        const token = localStorage.getItem("token")
        await this.props.syncAsset(token, val.type_sync, val.no_asset, val.date1)
        this.setState({confirm: 'sync'})
        this.openConfirm()
        this.openModsync()
        this.getDataAsset()
    }

    openModsync = () => { this.setState({openSync: !this.state.openSync}) }

    ExportMaster = () => {
        const token = localStorage.getItem('token')
        this.props.exportMaster(token)
    }

    onChangeHandler = e => {
        const {size, type} = e.target.files[0]
        if (size >= 5120000) {
            this.setState({errMsg: "Maximum upload size 5 MB"})
            this.uploadAlert()
        } else if (type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && type !== 'application/vnd.ms-excel') {
            this.setState({errMsg: 'Invalid file type. Only excel files are allowed.'})
            this.uploadAlert()
        } else {
            this.setState({fileUpload: e.target.files[0]})
        }
    }

    uploadMaster = async () => {
        const token = localStorage.getItem('token')
        const data = new FormData()
        data.append('master', this.state.fileUpload)
        await this.props.uploadMasterAsset(token, data)
        this.props.resetError()
        this.setState({modalUpload: false, confirm: 'upload'})
        this.openConfirm()
        this.getDataAsset()
    }

    componentDidUpdate() {
        const {isError, isExport, isSync} = this.props.asset
        if (isError) {
            this.props.resetError()
            this.showAlert()
        } else if (isExport) {
            this.props.resetError()
            this.DownloadMaster()
        } else if (isSync === false) {
            this.setState({confirm: 'syncfalse'})
            this.openConfirm()
            this.props.resetError()
        }
    }

    onSearch = (e) => {
        this.setState({search: e.target.value})
        if (e.key === 'Enter') {
            this.getDataAsset({limit: 10, search: this.state.search})
        }
    }

    componentDidMount() {
        this.getDataAsset()
    }

    cekDownload = () => {
        const {listAsset} = this.state
        if (listAsset.length > 0) {
            this.chooseDownload()
        } else {
            this.setState({confirm: 'failList'})
            this.openConfirm()
        }
    }

    chooseDownload = () => { 
        this.setState({openChoose: !this.state.openChoose}) 
    }

    getDataAsset = async (value) => {
        const token = localStorage.getItem("token")
        const { page } = this.props.asset
        const { filters } = this.state
        const search = value === undefined ? '' : this.state.search
        const limit  = value === undefined ? this.state.limit : value.limit
        await this.props.getAllCoa(token)
        await this.props.getAsset(token, limit, search, page.currentPage, 'master', filters)
        this.setState({limit: value === undefined ? 10 : value.limit})
    }

    menuButtonClick(ev) {
        ev.preventDefault();
        this.onSetOpen(!this.state.open);
    }

    onSetOpen(open) {
        this.setState({ open });
    }

    prosesOpenUpdate = async (val) => {
        this.setState({detail: val})
        this.openModalEdit()
    }

    updateAsset = async (value) => {
        const token = localStorage.getItem("token")
        const { detail } = this.state
        const data = { record_type: value.record_type }
        await this.props.updateAsset(token, detail.id, data)
        this.openModalEdit()
        this.setState({confirm: 'update'})
        this.openConfirm()
        this.getDataAsset()
    }

    render() {
        const {isOpen, dropOpen, dropOpenNum, detail, alert, upload, errMsg, listAsset} = this.state
        const {dataAsset, isGet, alertM, alertMsg, alertUpload, page} = this.props.asset
        const { dataOption, dataAll } = this.props.coa
        // console.log(dataAll)
        const level = localStorage.getItem('level')
        const names = localStorage.getItem('name')

        // Filter Panel state
        const { isPanelOpen, activeTab, filters } = this.state;
        const activeCount = Object.values(filters).flat().length;

        return (
            <>
                <div className={styleTrans.app}>
                    <NewNavbar handleSidebar={this.prosesSidebar} handleRoute={this.goRoute} />

                    <div className={`${styleTrans.mainContent} ${this.state.sidebarOpen ? styleTrans.collapsedContent : ''}`}>
                        <h2 className={styleTrans.pageTitle}>My Asset</h2>

                        {/* ── Row 1: Show entries + QR toggle ── */}
                        <div className={styleTrans.searchContainer}>
                            <div>
                                <text>Show: </text>
                                <ButtonDropdown className={style.drop} isOpen={dropOpen} toggle={this.dropDown}>
                                    <DropdownToggle caret color="light">
                                        {this.state.limit}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem className={style.item} onClick={() => this.getDataAsset({limit: 10,   search: ''})}>10</DropdownItem>
                                        <DropdownItem className={style.item} onClick={() => this.getDataAsset({limit: 20,   search: ''})}>20</DropdownItem>
                                        <DropdownItem className={style.item} onClick={() => this.getDataAsset({limit: 50,   search: ''})}>50</DropdownItem>
                                        <DropdownItem className={style.item} onClick={() => this.getDataAsset({limit: 100,  search: ''})}>100</DropdownItem>
                                        <DropdownItem className={style.item} onClick={() => this.getDataAsset({limit: 200,  search: ''})}>200</DropdownItem>
                                        <DropdownItem className={style.item} onClick={() => this.getDataAsset({limit: 500,  search: ''})}>500</DropdownItem>
                                        <DropdownItem className={style.item} onClick={() => this.getDataAsset({limit: 1000, search: ''})}>1000</DropdownItem>
                                        <DropdownItem className={style.item} onClick={() => this.getDataAsset({limit: 'all',search: ''})}>All</DropdownItem>
                                    </DropdownMenu>
                                </ButtonDropdown>
                            </div>
                            <Row className='borderRed'>
                                <Col md={4}>
                                    <text>Qr code</text>
                                </Col>
                                <Col md={8} className='nullPading'>
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={this.state.onQr}
                                            onChange={this.toggleQr}
                                        />
                                        <span className="slider round"></span>
                                        <span style={{ marginLeft: '10px' }}>
                                            {this.state.onQr ? 'ON' : 'OFF'}
                                        </span>
                                    </label>
                                </Col>
                            </Row>
                        </div>

                        {/* ── Row 2: Action buttons + Search + Filter Panel ── */}
                        <div className={styleTrans.searchContainer}>
                            <div className='rowGeneral'>
                                {/* ── Filter Panel (menggantikan tombol Filter lama) ── */}
                                <div className={stylesPanel.wrapper} style={{ marginRight: '4px' }}>
                                    {/* Trigger Button */}
                                    <button
                                        className={`${stylesPanel.triggerBtn} ${isPanelOpen ? stylesPanel.triggerActive : ""}`}
                                        onClick={this.togglePanel}
                                    >
                                        <span className={stylesPanel.triggerIcon}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                                            </svg>
                                        </span>
                                        <span>Filter</span>
                                        {activeCount > 0 && (
                                            <span className={stylesPanel.badge}>{activeCount}</span>
                                        )}
                                        <span className={`${stylesPanel.chevron} ${isPanelOpen ? stylesPanel.chevronUp : ""}`}>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                                <polyline points="6 9 12 15 18 9" />
                                            </svg>
                                        </span>
                                    </button>

                                    {/* Dropdown Panel */}
                                    <div className={`${stylesPanel.panel} ${isPanelOpen ? stylesPanel.panelOpen : ""}`}>
                                        <div className={stylesPanel.panelInner}>

                                            {/* Header */}
                                            <div className={stylesPanel.panelHeader}>
                                                <div className={stylesPanel.panelTitle}>
                                                    <span className={stylesPanel.panelTitleDot} />
                                                    Advanced Filter
                                                </div>
                                                {activeCount > 0 && (
                                                    <span className={stylesPanel.activePill}>{activeCount} aktif</span>
                                                )}
                                            </div>

                                            <div className={stylesPanel.panelBody}>

                                                {/* Status Section */}
                                                <div className={stylesPanel.statusSection}>
                                                    <p className={stylesPanel.sectionLabel}>Status Asset</p>
                                                    <div className={stylesPanel.statusList}>
                                                        {STATUS_OPTIONS.map((opt) => {
                                                            const isSelected = filters.status.includes(opt.value);
                                                            return (
                                                                <button
                                                                    key={opt.value}
                                                                    className={`${stylesPanel.statusChip} ${isSelected ? stylesPanel.statusChipActive : ""}`}
                                                                    style={isSelected ? { "--chip-color": opt.color } : {}}
                                                                    onClick={() => this.toggleItem("status", opt.value)}
                                                                >
                                                                    <span className={stylesPanel.statusDot} style={{ backgroundColor: opt.color }} />
                                                                    <span className={stylesPanel.statusIcon}>{opt.icon}</span>
                                                                    {opt.label}
                                                                    {isSelected && <span className={stylesPanel.checkMark}>✓</span>}
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                </div>

                                                <div className={stylesPanel.divider} />

                                                {/* COA Section */}
                                                <div className={stylesPanel.coaSection}>
                                                    <p className={stylesPanel.sectionLabel}>Chart of Account</p>

                                                    {/* Tabs */}
                                                    <div className={stylesPanel.tabs}>
                                                        {Object.keys(TAB_LABELS).map((tab) => {
                                                            const count = filters[tab].length;
                                                            return (
                                                                <button
                                                                    key={tab}
                                                                    className={`${stylesPanel.tab} ${activeTab === tab ? stylesPanel.tabActive : ""}`}
                                                                    onClick={() => this.switchTab(tab)}
                                                                >
                                                                    {TAB_LABELS[tab]}
                                                                    {count > 0 && (
                                                                        <span className={stylesPanel.tabBadge}>{count}</span>
                                                                    )}
                                                                </button>
                                                            );
                                                        })}
                                                    </div>

                                                    {/* Option List */}
                                                    <div className={stylesPanel.optionList}>
                                                        {dataOption[activeTab] && dataOption[activeTab].map((opt) => {
                                                            const isSelected = filters[activeTab].includes(opt.value);
                                                            return (
                                                                <label key={opt.value} className={stylesPanel.optionRow}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className={stylesPanel.hiddenCheck}
                                                                        checked={isSelected}
                                                                        onChange={() => this.toggleItem(activeTab, opt.value)}
                                                                    />
                                                                    <span className={`${stylesPanel.customCheck} ${isSelected ? stylesPanel.customCheckActive : ""}`}>
                                                                        {isSelected && (
                                                                            <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="white" strokeWidth="2.5">
                                                                                <polyline points="2 6 5 9 10 3" />
                                                                            </svg>
                                                                        )}
                                                                    </span>
                                                                    <span className={stylesPanel.optionCode}>{opt.value}</span>
                                                                    <span className={stylesPanel.optionDesc}>
                                                                        {opt.label.split(" - ")[1]}
                                                                    </span>
                                                                </label>
                                                            );
                                                        })}
                                                    </div>
                                                </div>

                                            </div>

                                            {/* Footer */}
                                            <div className={stylesPanel.panelFooter}>
                                                <button className={stylesPanel.resetBtn} onClick={this.handleReset}>
                                                    Reset Semua
                                                </button>
                                                <button className={stylesPanel.applyBtn} onClick={this.handleApply}>
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                                        <polyline points="20 6 9 17 4 12" />
                                                    </svg>
                                                    Terapkan Filter
                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                    {/* Backdrop */}
                                    {isPanelOpen && (
                                        <div className={stylesPanel.backdrop} onClick={this.closePanel} />
                                    )}
                                </div>
                                {/* ── End Filter Panel ── */}
                                <Button color="success" size="lg" onClick={this.cekDownload}>Download</Button>
                                {level === '1' && (
                                    <>
                                        {/* <Button className='ml-1' color="warning" size="lg" onClick={this.openModalUpload}>Upload</Button> */}
                                        <Button className='ml-1' color="primary" size="lg" onClick={this.openModsync}>Synchronize</Button>
                                    </>
                                )}

                            </div>

                            <div className={style.searchEmail2}>
                                <text>Search: </text>
                                <Input
                                    className={style.search}
                                    onChange={this.onSearch}
                                    value={this.state.search}
                                    onKeyPress={this.onSearch}
                                >
                                    <FaSearch size={20} />
                                </Input>
                            </div>
                        </div>

                        {/* ── Table ── */}
                        <table className={`${styleTrans.table} ${dataAsset.length > 0 ? styleTrans.tableFull : ''}`}>
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            className='mr-2'
                                            type='checkbox'
                                            checked={listAsset.length === 0 ? false : listAsset.length === dataAsset.length}
                                            onChange={() => listAsset.length === dataAsset.length ? this.chekRej('all') : this.chekApp('all')}
                                        />
                                    </th>
                                    <th>No</th>
                                    {this.state.onQr && <th className='indexStat'>Qr code</th>}
                                    <th>Asset</th>
                                    <th>SNo.</th>
                                    <th>Cap.Date</th>
                                    <th>Asset Description</th>
                                    <th>Acquis.val.</th>
                                    <th>Accum.dep.</th>
                                    <th>Book val.</th>
                                    <th>Plant</th>
                                    <th>Cost Ctr</th>
                                    <th>Cost Ctr Name</th>
                                    <th>MERK</th>
                                    <th>SATUAN</th>
                                    <th>JUMLAH</th>
                                    <th>LOKASI</th>
                                    <th>KATEGORI</th>
                                    <th>COA ASSET</th>
                                    <th>COA BEBAN</th>
                                    <th>COA AKUMULASI</th>
                                    <th>UMUR ASSET (Bulan)</th>
                                    <th>NILAI DEPRE / BULAN</th>
                                    <th>SISA UMUR ASSET (SAMPAI BOOK.VAL 0) (Bulan)</th>
                                    <th>STATUS</th>
                                    <th>Record</th>
                                    {level === '1' && <th>OPSI</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {dataAsset.length !== 0 && dataAsset.map((item, index) => {
                                const diffVal = parseInt(item.accum_dep)
                                const now = moment()
                                // const past = parseInt(moment(item.tanggal).format('DD')) < 16 ? moment(item.tanggal).subtract(1, 'month') : moment(item.tanggal)  
                                const past = parseInt(moment(item.tanggal).format('DD')) > 15 ? moment(item.tanggal).add(1, 'month') : moment(item.tanggal)  
                                // const past = moment(item.tanggal)

                                const diffMonth =
                                (now.year() - past.year()) * 12 +
                                (now.month() - past.month())

                                const valMonth = diffVal === 0 ? 0 : diffVal / diffMonth
                                const monthRemain = valMonth === 0 ? 0 : (parseInt(item.nilai_acquis) / Math.abs(valMonth)) - diffMonth
                                return (
                                    <tr key={item.id} className={item.status === '100' ? 'yellow' : item.status === '0' ? 'fail' : ''}>
                                        <td>
                                            <input
                                                type='checkbox'
                                                checked={listAsset.find(el => el === item.id) !== undefined}
                                                onChange={listAsset.find(el => el === item.id) === undefined
                                                    ? () => this.chekApp(item.id)
                                                    : () => this.chekRej(item.id)}
                                            />
                                        </td>
                                        <td scope="row">{dataAsset.indexOf(item) + (((page.currentPage - 1) * page.limitPerPage) + 1)}</td>
                                        {this.state.onQr && (
                                            <td key={item.no_asset} ref={(el) => (this.barcodeRefs[item.no_asset] = el)}>
                                                <div style={{ position: "relative", width: 192, height: 192 }}>
                                                    <QRCode value={JSON.stringify({no: item.no_asset, cost: item.cost_center})} size={192} />
                                                    <img
                                                        src={logo}
                                                        alt="logo"
                                                        style={{
                                                            position: "absolute", top: "50%", left: "50%",
                                                            transform: "translate(-50%, -50%)",
                                                            width: 32, height: 32,
                                                            borderRadius: "8px", backgroundColor: "white", padding: "4px",
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        )}
                                        <td>{item.no_asset}</td>
                                        <td>{item.no_doc}</td>
                                        <td>{moment(item.tanggal).format('DD/MM/YYYY')}</td>
                                        <td>{item.nama_asset}</td>
                                        <td>{item.nilai_acquis == null ? 0 : item.nilai_acquis.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</td>
                                        <td>{item.accum_dep   == null ? 0 : item.accum_dep.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</td>
                                        <td>{item.nilai_buku  == null ? 0 : item.nilai_buku.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</td>
                                        <td>{item.kode_plant}</td>
                                        <td>{item.cost_center}</td>
                                        <td>{item.area}</td>
                                        <td>{item.merk}</td>
                                        <td>{item.satuan}</td>
                                        <td>{item.unit}</td>
                                        <td>{item.lokasi}</td>
                                        <td>{item.kategori}</td>
                                        <td>{item.coa?.find(x => dataAll.find(y => x === y.no_coa && y.type_coa === 'asset') !== undefined) || "-"}</td>
                                        <td>{item.coa?.find(x => dataAll.find(y => x === y.no_coa && y.type_coa === 'beban') !== undefined) || "-"}</td>
                                        <td>{item.coa?.find(x => dataAll.find(y => x === y.no_coa && y.type_coa === 'akumulasi') !== undefined) || "-"}</td>
                                        <td>{diffMonth} Bulan</td>
                                        <td>{item.nilai_buku == 0 ? 0 : `${Math.round(valMonth).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} / Bulan`}</td>
                                        <td>{diffMonth == 0 ? 'Belum Terdefinisi' : item.nilai_buku == 0 ? 0 : `${Math.round(monthRemain)} Bulan`}</td>
                                        <td>{
                                            item.status === '100' ? 'Asset belum di GR' 
                                            : item.status === '0' ? 'Asset telah didisposal' 
                                            : item.status === '11' || item.status === '1' ? item.keterangan
                                            : 'available'
                                        }</td>
                                        <td>{!item.record_type ? 'SAP' : item.record_type}</td>
                                        {level === '1' && (
                                            <td>
                                                <Button size='sm' color='success' onClick={() => this.prosesOpenUpdate(item)}>
                                                    Update Record
                                                </Button>
                                            </td>
                                        )}
                                    </tr>
                                    )}
                                )}
                            </tbody>
                        </table>

                        {dataAsset.length === 0 && (
                            <div className={style.spinCol}>
                                <AiOutlineInbox size={50} className='mb-4' />
                                <div className='textInfo'>Data asset tidak ditemukan</div>
                            </div>
                        )}

                        {/* ── Pagination ── */}
                        <div>
                            <div className={style.infoPageEmail1}>
                                <text>Showing {page.currentPage} of {page.pages} pages</text>
                                <div className={style.pageButton}>
                                    <button className={style.btnPrev} disabled={page.prevLink === null} onClick={this.prev}>Prev</button>
                                    <button className={style.btnPrev} disabled={page.nextLink === null} onClick={this.next}>Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Modals ─────────────────────────────────────────────────── */}

                {/* Choose Download */}
                <Modal isOpen={this.state.openChoose} toggle={this.chooseDownload} size='xl'>
                    <ModalBody>
                        <div className={styleHome.mainContent}>
                            <main className={styleHome.mainSection}>
                                <h1 className={styleHome.title}>Pilih Download Data</h1>
                                <div className={`${styleHome.assetContainer} row`}>
                                    <div onClick={() => this.downloadData()} className="col-12 col-md-6 col-lg-3 mb-4">
                                        <div className={styleHome.assetCard1}>
                                            <BsTable size={150} className='mt-4 mb-4' />
                                            <p className='mt-2 mb-4 sizeCh'>Download Master Data</p>
                                        </div>
                                    </div>
                                    {this.state.onQr && (
                                        <div onClick={() => this.downloadBarcode()} className="col-12 col-md-6 col-lg-3 mb-4">
                                            <div className={styleHome.assetCard1}>
                                                <BsQrCode size={150} className='mt-4 mb-4' />
                                                <p className='mt-2 mb-4 sizeCh'>Download Qr Code</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </main>
                        </div>
                        <hr />
                        <div className='rowBetween'>
                            <div></div>
                            <Button onClick={this.chooseDownload} color='secondary'>Close</Button>
                        </div>
                    </ModalBody>
                </Modal>

                {/* Upload */}
                <Modal toggle={this.openModalUpload} isOpen={this.state.modalUpload}>
                    <ModalHeader>Upload Master Asset</ModalHeader>
                    <ModalBody className={style.modalUpload}>
                        <div className={style.titleModalUpload}>
                            <text>Upload File: </text>
                            <div className={style.uploadFileInput}>
                                <AiOutlineFileExcel size={35} />
                                <div className="ml-3">
                                    <Input type="file" name="file" accept=".xls,.xlsx" onChange={this.onChangeHandler} />
                                </div>
                            </div>
                        </div>
                        <div className={style.btnUpload}>
                            <Button color="info" onClick={this.downloadTemplate}>Download Template</Button>
                            <Button color="primary" disabled={this.state.fileUpload === ""} onClick={this.uploadMaster}>Upload</Button>
                            <Button onClick={this.openModalUpload}>Cancel</Button>
                        </div>
                    </ModalBody>
                </Modal>

                {/* Synchronize */}
                <Modal toggle={this.openModsync} isOpen={this.state.openSync} size='lg'>
                    <ModalHeader>Synchronize Data Asset</ModalHeader>
                    <Formik
                        initialValues={{ type_sync: '', no_asset: '', date1: '' }}
                        validationSchema={filterSchema}
                        onSubmit={(values) => { this.prosesSync(values) }}
                    >
                        {({ handleChange, handleBlur, handleSubmit, values }) => (
                            <ModalBody>
                                <Row className="mb-2 rowRinci">
                                    <Col md={3}>Pilih Tipe Synchronize</Col>
                                    <Col md={9} className="colRinci">:
                                        <Input type="select" className="inputRinci" value={values.type_sync} onBlur={handleBlur("type_sync")} onChange={handleChange('type_sync')}>
                                            <option value=''>Pilih</option>
                                            <option value="no">No Asset</option>
                                            <option value="time">Periode</option>
                                        </Input>
                                    </Col>
                                </Row>
                                <Row className="mb-2 rowRinci">
                                    <Col md={3}>No Asset</Col>
                                    <Col md={9} className="colRinci">:
                                        <Input type="text" className="inputRinci" disabled={values.type_sync !== 'no'} value={values.no_asset} onBlur={handleBlur("no_asset")} onChange={handleChange("no_asset")} />
                                    </Col>
                                </Row>
                                <Row className="mb-2 rowRinci">
                                    <Col md={3}>Periode</Col>
                                    <Col md={9} className="colRinci">:
                                        <Input type="date" className="inputRinci" disabled={values.type_sync !== 'time'} value={values.date1} onBlur={handleBlur("date1")} onChange={handleChange("date1")} />
                                    </Col>
                                </Row>
                                <hr/>
                                <div className={style.foot}>
                                    <div></div>
                                    <div>
                                        <Button
                                            disabled={
                                                values.type_sync === '' ||
                                                (values.type_sync === 'time' && values.date1 === '') ||
                                                (values.type_sync === 'no' && values.no_asset === '')
                                            }
                                            className="mr-2" onClick={handleSubmit} color="primary"
                                        >
                                            Synchronize
                                        </Button>
                                        <Button className="mr-3" onClick={this.openModsync}>Cancel</Button>
                                    </div>
                                </div>
                            </ModalBody>
                        )}
                    </Formik>
                </Modal>

                {/* Loading spinner */}
                <Modal isOpen={this.props.asset.isLoading || this.state.isLoading} size="sm">
                    <ModalBody>
                        <div className={style.cekUpdate}>
                            <Spinner />
                            <div>Waiting....</div>
                        </div>
                    </ModalBody>
                </Modal>

                {/* Confirm result */}
                <Modal isOpen={this.state.modalConfirm} toggle={this.openConfirm} size="sm">
                    <ModalBody>
                        {this.state.confirm === 'update' && (
                            <div className={style.cekUpdate}>
                                <AiFillCheckCircle size={80} className={style.green} />
                                <div className={style.sucUpdate}>Berhasil Update Asset</div>
                            </div>
                        )}
                        {this.state.confirm === 'add' && (
                            <div className={style.cekUpdate}>
                                <AiFillCheckCircle size={80} className={style.green} />
                                <div className={style.sucUpdate}>Berhasil Menambahkan Asset</div>
                            </div>
                        )}
                        {this.state.confirm === 'upload' && (
                            <div className={style.cekUpdate}>
                                <AiFillCheckCircle size={80} className={style.green} />
                                <div className={style.sucUpdate}>Berhasil Mengupload Master Asset</div>
                            </div>
                        )}
                        {this.state.confirm === 'sync' && (
                            <div className={style.cekUpdate}>
                                <AiFillCheckCircle size={80} className={style.green} />
                                <div className={style.sucUpdate}>Berhasil Synchronize Data Asset</div>
                            </div>
                        )}
                        {this.state.confirm === 'syncfalse' && (
                            <div className={style.cekUpdate}>
                                <AiOutlineClose size={80} className={style.red} />
                                <div className={style.sucUpdate}>Gagal Synchronize Data</div>
                                <div className={style.sucUpdate}>Data Asset Tidak Ditemukan</div>
                            </div>
                        )}
                        {this.state.confirm === 'failList' && (
                            <div className={style.cekUpdate}>
                                <AiOutlineClose size={80} className={style.red} />
                                <div className={style.sucUpdate}>Gagal Download</div>
                                <div className={style.sucUpdate}>Ceklist Data Asset Terlebih Dahulu</div>
                            </div>
                        )}
                    </ModalBody>
                </Modal>

                {/* Update Record */}
                <Modal isOpen={this.state.modalEdit} toggle={this.openModalEdit} size="lg">
                    <ModalHeader>Update Record Type Asset</ModalHeader>
                    <ModalBody>
                        <div className="mainRinci2">
                            <div className="leftRinci2 mb-5">
                                <div className="titRinci">{detail.nama_asset}</div>
                                <img
                                    src={detail.pict === undefined || detail.pict.length === 0
                                        ? placeholder
                                        : `${REACT_APP_BACKEND_URL}/${detail.pict[detail.pict.length - 1].path}`}
                                    className="imgRinci"
                                    alt="asset"
                                />
                                <Input type="file" className='mt-2' onChange={this.uploadPicture}>Upload Picture</Input>
                            </div>
                            <Formik
                                initialValues={{ record_type: detail.record_type === null ? '' : detail.record_type }}
                                validationSchema={stockSchema}
                                onSubmit={(values) => { this.updateAsset(values) }}
                            >
                                {({ handleChange, handleBlur, handleSubmit, values, errors }) => (
                                    <div className="rightRinci2">
                                        <div>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>No Asset</Col>
                                                <Col md={9} className="colRinci">: <Input className="inputRinci" value={detail.no_asset} disabled /></Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Nama Asset</Col>
                                                <Col md={9} className="colRinci">: <Input className="inputRinci" value={detail.nama_asset} disabled /></Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Merk</Col>
                                                <Col md={9} className="colRinci">: <Input type="text" className="inputRinci" value={detail.merk} disabled /></Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Acquis Val</Col>
                                                <Col md={9} className="colRinci">: <Input type="text" className="inputRinci" value={detail.nilai_acquis} disabled /></Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Accum Dep</Col>
                                                <Col md={9} className="colRinci">: <Input type="text" className="inputRinci" value={detail.accum_dep} disabled /></Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Cost Center</Col>
                                                <Col md={9} className="colRinci">: <Input type="text" className="inputRinci" value={detail.cost_center} disabled /></Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Cost Center Name</Col>
                                                <Col md={9} className="colRinci">: <Input type="text" className="inputRinci" value={detail.area} disabled /></Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Satuan</Col>
                                                <Col md={9} className="colRinci">:
                                                    <Input type="select" className="inputRinci" value={detail.satuan} disabled={!(level === '5' || level === '9')} onChange={handleChange("satuan")}>
                                                        <option>{detail.satuan}</option>
                                                        <option value="UNIT">UNIT</option>
                                                        <option value="PAKET">PAKET</option>
                                                    </Input>
                                                </Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Unit</Col>
                                                <Col md={9} className="colRinci">:
                                                    <Input type="text" className="inputRinci" value={detail.unit} disabled={!(level === '5' || level === '9')} onChange={handleChange("unit")} />
                                                </Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Lokasi</Col>
                                                <Col md={9} className="colRinci">:
                                                    <Input type="text" className="inputRinci" value={detail.lokasi} disabled={!(level === '5' || level === '9')} onChange={handleChange("lokasi")} />
                                                </Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Status Fisik</Col>
                                                <Col md={9} className="colRinci">:
                                                    <Input type="select" className="inputRinci" value={detail.fisik} disabled={!((level === '5' || level === '9') && (detail.grouping === null || detail.grouping === ''))} onChange={e => { handleChange("status_fisik"); this.updateCond({tipe: "status_fisik", val: e.target.value}) }}>
                                                        <option>{detail.status_fisik}</option>
                                                        <option value="ada">Ada</option>
                                                        <option value="tidak ada">Tidak Ada</option>
                                                    </Input>
                                                </Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Kondisi</Col>
                                                <Col md={9} className="colRinci">:
                                                    <Input type="select" className="inputRinci" value={detail.fisik} disabled={!((level === '5' || level === '9') && (detail.grouping === null || detail.grouping === ''))} onChange={e => { handleChange("kondisi"); this.updateCond({tipe: "kondisi", val: e.target.value}) }}>
                                                        <option>{detail.kondisi === "" ? "-" : detail.kondisi}</option>
                                                        <option value="baik">Baik</option>
                                                        <option value="rusak">Rusak</option>
                                                        <option value="">-</option>
                                                    </Input>
                                                </Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Status Aset</Col>
                                                <Col md={9} className="colRinci">:
                                                    <Input type="select" className="inputRinci" value={detail.grouping} disabled={!(level === '5' || level === '9')} onClick={() => this.listStatus(detail)}>
                                                        <option>{detail.grouping}</option>
                                                    </Input>
                                                </Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Keterangan</Col>
                                                <Col md={9} className="colRinci">:
                                                    <Input type="text" className="inputRinci" value={detail.keterangan} disabled={!(level === '5' || level === '9')} onChange={handleChange("keterangan")} />
                                                </Col>
                                            </Row>
                                            <Row className="mb-2 rowRinci">
                                                <Col md={3}>Record Type</Col>
                                                <Col md={9} className="colRinci">:
                                                    <Input type="select" className="inputRinci" value={!values.record_type ? 'SAP' : values.record_type} onBlur={handleBlur("record_type")} onChange={handleChange("record_type")}>
                                                        <option>-Pilih-</option>
                                                        <option value="WEB">WEB</option>
                                                        <option value="SAP">SAP</option>
                                                    </Input>
                                                </Col>
                                            </Row>
                                        </div>
                                        <ModalFooter>
                                            <Button className="mr-3" size="md" color="primary" onClick={handleSubmit}>Save</Button>
                                            <Button size="md" color="secondary" onClick={() => this.openModalEdit()}>Close</Button>
                                        </ModalFooter>
                                    </div>
                                )}
                            </Formik>
                        </div>
                    </ModalBody>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = state => ({
    asset: state.asset,
    coa: state.coa
})

const mapDispatchToProps = {
    logout: auth.logout,
    getAsset: asset.getAsset,
    updateAsset: asset.updateAsset,
    resetError: asset.resetError,
    uploadMasterAsset: asset.uploadMasterAsset,
    nextPage: asset.nextPage,
    syncAsset: asset.syncAsset,
    getAllCoa: coa.getAllCoa
}

export default connect(mapStateToProps, mapDispatchToProps)(Asset)